var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Handle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8C3 7.72386 3.19188 7.5 3.42857 7.5L20.5714 7.5C20.8081 7.5 21 7.72386 21 8C21 8.27614 20.8081 8.5 20.5714 8.5L3.42857 8.5C3.19188 8.5 3 8.27614 3 8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 11.7239 3.19188 11.5 3.42857 11.5L20.5714 11.5C20.8081 11.5 21 11.7239 21 12C21 12.2761 20.8081 12.5 20.5714 12.5L3.42857 12.5C3.19188 12.5 3 12.2761 3 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 16C3 15.7239 3.19188 15.5 3.42857 15.5L20.5714 15.5C20.8081 15.5 21 15.7239 21 16C21 16.2761 20.8081 16.5 20.5714 16.5L3.42857 16.5C3.19188 16.5 3 16.2761 3 16Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.03383bc4fbb42cd9e10d719b6bdc5279.svg";
export { ForwardRef as ReactComponent };